// extracted by mini-css-extract-plugin
export var Container = "Container-module--Container---XaXR";
export var aniSpin = "Container-module--ani-spin--3C-8z";
export var indent = "Container-module--indent--anbqq";